<template>
  <base-modal
    :is-opened="isOpened"
    :hide="handleHide"
    :modal-class="modalClass"
    :auto-dismiss="!dirty"
    :on-top="onTop"
  >
    <template #before>
      <slot name="before" />
    </template>
    <template #default="{ hide, dismiss, isDismissing, resolveDismissing }">
      <div
        :class="[$style.dialog, $style[`size_${size}`], contentClass]"
        role="document"
      >
        <slot
          name="confirm"
          :hide="hide"
          :dismiss="dismiss"
          :is-dismissing="isDismissing"
          :resolve-dismissing="resolveDismissing"
        >
          <native-close-confirmation
            v-if="isDismissing"
            :confimation-text="confirmationText"
            @resolve="resolveDismissing"
          />
        </slot>
        <slot
          :hide="hide"
          :dismiss="dismiss"
          :set-dirty="setDirty"
        />
      </div>
    </template>
  </base-modal>
</template>

<script>
import { toRefs, watch } from 'vue';
import { useModalNext } from '@/shared/legacy/ui/modal-next/use-modal-next';
import { trlMessage } from '@/shared/lib/i18n';
import BaseModal from '@/shared/legacy/ui/modal-next/modal-next.vue';
import NativeCloseConfirmation from '@/shared/legacy/ui/modal-next/native-close-confirmation.vue';

export default {
  name: 'ModalWrapper',
  components: {
    BaseModal,
    NativeCloseConfirmation
  },
  props: {
    open: Boolean,
    confirmationText: {
      type: String,
      default: trlMessage('modal.close.confirm')
    },
    size: {
      type: String,
      default: 'default' /* 775px */
    },
    onTop: BaseModal.props.onTop,
    modalClass: {
      type: String,
      default: ''
    },
    contentClass: {
      type: String,
      default: ''
    }
  },
  emits: ['change', 'show', 'hide'],
  setup(props, { emit }) {
    const { open } = toRefs(props);
    const { show, hide, isOpened } = useModalNext();
    watch(
      open,
      (open) => {
        if (open) {
          show();
          return emit('show');
        }
        hide();
        emit('hide');
      },
      { immediate: true }
    );
    return {
      isOpened
    };
  },
  data() {
    return {
      dirty: false
    };
  },
  watch: {
    open(open) {
      if (!open) {
        this.dirty = false;
      }
    }
  },
  methods: {
    handleHide() {
      this.$emit('change', false);
    },
    setDirty(flag) {
      this.dirty = flag;
    }
  }
};
</script>

<style module>
.dialog {
  position: relative;
  margin: 75px auto;
  height: max-content;

  @media print {
    margin: 0;
    width: 100% !important;
  }
}

.size_default {
  width: 764px;
}

.size_wysiwyg {
  width: 1025px;
}

.size_maxcontent {
  width: max-content;
}
</style>

<i18n lang="json">{}</i18n>
